/**
 * contains the abi and contract address
*/

class ZProjectsContract {
    constructor() {
        this.abi = [
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sequenceHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "sampleHash",
				"type": "bytes32"
			}
		],
		"name": "SampleInSequence",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "address",
				"name": "user",
				"type": "address"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "previousSequence",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "newSequence",
				"type": "bytes32"
			},
			{
				"indexed": false,
				"internalType": "string",
				"name": "title",
				"type": "string"
			},
			{
				"indexed": false,
				"internalType": "uint32",
				"name": "bpm",
				"type": "uint32"
			}
		],
		"name": "SequenceEdited",
		"type": "event"
	},
	{
		"anonymous": false,
		"inputs": [
			{
				"indexed": true,
				"internalType": "bytes32",
				"name": "projectHash",
				"type": "bytes32"
			},
			{
				"indexed": true,
				"internalType": "uint256",
				"name": "zoraTokenId",
				"type": "uint256"
			}
		],
		"name": "ZoraProject",
		"type": "event"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "previousSequence",
				"type": "bytes32"
			},
			{
				"internalType": "bytes32",
				"name": "newSequence",
				"type": "bytes32"
			},
			{
				"internalType": "string",
				"name": "title",
				"type": "string"
			},
			{
				"internalType": "bytes32[]",
				"name": "samples",
				"type": "bytes32[]"
			},
			{
				"internalType": "uint32",
				"name": "bpm",
				"type": "uint32"
			}
		],
		"name": "editSequence",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	},
	{
		"inputs": [
			{
				"internalType": "bytes32",
				"name": "projectHash",
				"type": "bytes32"
			},
			{
				"internalType": "uint256",
				"name": "zoraTokenId",
				"type": "uint256"
			}
		],
		"name": "zoraProject",
		"outputs": [],
		"stateMutability": "nonpayable",
		"type": "function"
	}
        ];

        this.contractAddress = '0x27Fd050dF7c0c603A407f1BC4fd0ED634824270E';
    }

    getContract(web3) {
        return new web3.eth.Contract(this.abi, this.contractAddress);
    }
}

export default ZProjectsContract;
